export default "__VITE_ASSET__NjsInB4H__"